import {init as initDataLayer, pushBackendEvents} from "./gtm/dataLayer.js";
import {onDomContentLoaded} from "./common/lifecycle.js";
import {init as initTracking} from "./gtm/tracking.js";

initDataLayer();
onDomContentLoaded(() => {
    pushBackendEvents();
    initTracking();
});
